import React from 'react';

/**
 * Input — поле ввода с лейблом и сообщением об ошибке.
 *
 * @param {string} label
 * @param {string} error — текст ошибки
 * @param {React.ReactNode} icon — иконка слева (опционально)
 * @param {'input'|'textarea'|'select'} as — тег элемента
 */
const Input = React.forwardRef(({
  label,
  error,
  icon,
  as: Tag = 'input',
  className = '',
  id,
  children,
  ...rest
}, ref) => {
  const inputId = id || (label ? label.toLowerCase().replace(/\s+/g, '-') : undefined);

  const inputClasses = [
    'bm-input',
    error ? 'bm-input--error' : '',
    icon ? 'bm-input--with-icon' : '',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <div className="bm-input-group">
      {label && (
        <label className="bm-label" htmlFor={inputId}>
          {label}
        </label>
      )}
      <div style={{ position: 'relative' }}>
        {icon && (
          <span
            style={{
              position: 'absolute',
              left: '12px',
              top: '50%',
              transform: 'translateY(-50%)',
              color: 'var(--bm-text-muted)',
              display: 'flex',
              pointerEvents: 'none',
            }}
          >
            {icon}
          </span>
        )}
        <Tag
          ref={ref}
          id={inputId}
          className={inputClasses}
          style={icon ? { paddingLeft: '40px' } : undefined}
          {...rest}
        >
          {children}
        </Tag>
      </div>
      {error && <span className="bm-input-error-msg">{error}</span>}
    </div>
  );
});

Input.displayName = 'Input';

export default Input;
